<template>
  <div
    class="auth-layout relative flex min-h-screen w-full flex-col items-center justify-center px-6 py-20"
  >
    <div class="absolute top-5 left-6 h-11 w-44">
      <div
        class="bg-contain bg-no-repeat h-full w-full"
        style="background-image: url('/logo/studio_full_light.png')"
      />
    </div>

    <main class="flex w-full max-w-[528px] flex-col">
      <slot />
    </main>
  </div>
</template>

<style scoped>
.auth-layout {
  background-color: theme('colors.surface.50');
  background-image: radial-gradient(
    circle,
    theme('colors.surface.200') 1px,
    transparent 1.2px
  );
  background-size: 18px 18px;
  background-repeat: repeat;
}
</style>
